import { Magic } from "magic-sdk";

import logger from "shared/logger";

const magic = (key: string) => {
  logger.debug({ key }, "using magic api key");
  return new Magic(key);
};

export default magic;
